
import { mapGetters } from 'vuex'
export default {
 name: "ModuleContent",
 props: {
    id: {
      default: '',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
 },
 data() {
    return {
      startActive: this.active !== '',
    }
  },
  computed: {
    ...mapGetters({
      activeModule : 'pages/getActiveModule',
    }),
  },
}
